import { render, staticRenderFns } from "./OperationalDataStatisticsReportOperations.vue?vue&type=template&id=18af35a0&scoped=true&"
import script from "./OperationalDataStatisticsReportOperations.vue?vue&type=script&lang=js&"
export * from "./OperationalDataStatisticsReportOperations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18af35a0",
  null
  
)

export default component.exports